// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"686":"13dac1c4","858":"18243847"}[chunkId] + ".chunk.js";
};